import { MAX_LINE_QUANTITY } from "@models/shoppingCart";

/**
 * The ceiling of any quantity the shopper enters (product page, cart, checkout): the
 * vendor's stock where it is known, never above the API's per-line limit, and never below
 * 1 — a line is fixed by a switch or Remove, not by a quantity of 0.
 */
export const quantityCap = (available: number | undefined): number =>
    Math.max(1, Math.min(available ?? MAX_LINE_QUANTITY, MAX_LINE_QUANTITY));
